/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 *
 * @export
 * @interface VoiceAgentInferencerLiveKitCreate
 */
export interface VoiceAgentInferencerLiveKitCreate {
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  name: string;
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  serverUrl: string;
  /**
   * The API key of your LiveKit project (an identifier, not a secret). The API secret goes into the credential.
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  apiKey: string;
  /**
   * The name your agent registers under with LiveKit. It must match exactly, otherwise the agent is never dispatched into the room.
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  agentName: string;
  /**
   * Optional text sent verbatim to the agent as its job metadata (e.g. a JSON string). Leave empty if your agent does not expect any.
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  dispatchMetadata?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  maxDuration?: number;
  /**
   * Maximum number of conversations run in parallel. Set it to the concurrent agent session limit of your LiveKit plan.
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  maxConcurrency?: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKitCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the VoiceAgentInferencerLiveKitCreate interface.
 */
export function instanceOfVoiceAgentInferencerLiveKitCreate(value: object): value is VoiceAgentInferencerLiveKitCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('serverUrl' in value) || value['serverUrl'] === undefined) return false;
  if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
  if (!('agentName' in value) || value['agentName'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerLiveKitCreateFromJSON(json: any): VoiceAgentInferencerLiveKitCreate {
  return VoiceAgentInferencerLiveKitCreateFromJSONTyped(json, false);
}

export function VoiceAgentInferencerLiveKitCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerLiveKitCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    serverUrl: json['server_url'],
    apiKey: json['api_key'],
    agentName: json['agent_name'],
    dispatchMetadata: json['dispatch_metadata'] == null ? undefined : json['dispatch_metadata'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    maxConcurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function VoiceAgentInferencerLiveKitCreateToJSON(value?: VoiceAgentInferencerLiveKitCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    server_url: value['serverUrl'],
    api_key: value['apiKey'],
    agent_name: value['agentName'],
    dispatch_metadata: value['dispatchMetadata'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    max_concurrency: value['maxConcurrency'],
    credential_id: value['credentialId'],
  };
}
